export default __webpack_public_path__ + "../staticImages/slot-machine-voucher.svg";